import React, {useEffect, useState} from "react";
import "./_page-10.scss";
import {Form} from "react-bootstrap";
import {FormSelect} from "../../../index";
import useVMStore from "../../../../store";
import {IPage10} from "../../../../interfaces";

export default function Page10() {
    const name = "page10";

    const {data, setData} = useVMStore();

    const values: {label: string; el: "que" | "lan" | "fas"}[] = [
        {
            label: "Wieviele Querschnitte wünschen Sie? *",
            el: "que",
        },
        {
            label: "Wieviele Längsschnitte wünschen Sie? *",
            el: "lan",
        },
        {
            label: "Wieviele Fassadenansichten wünschen Sie?",
            el: "fas",
        },
    ];

    const [is2D, setIs2D] = useState(false);

    const selectOptions = [
        "3D Modell inkl. gelayoutete 2D Grundrisse, Schnitte und Fassadenansichten",
        "Reines 3D Modell ohne gelayoutete 2D Grundrisse, Schnitte und Fassadenansichten",
    ];

    const _data: IPage10 = data[name];

    const _data4 = data["page4"];

    function changeType(val: string) {
        if (val !== selectOptions[0]) {
            setData(
                {
                    type: val,
                },
                "page10",
            );
        } else {
            setData(
                {
                    type: val,
                    que: "",
                    lan: "",
                    fas: "",
                },
                "page10",
            );
        }
    }

    useEffect(() => {
        setIs2D(_data4 === "2D");
    }, [_data4]);

    useEffect(() => {
        if (is2D && _data.type !== selectOptions[0]) {
            changeType(selectOptions[0]);
        }
    }, [is2D]);

    return (
        <Form className="page-10">
            <FormSelect
                data={selectOptions}
                value={_data.type}
                setValue={changeType}
                placeholder={"Art des Plans"}
                className={"pb-3 pb-sm-0" + (is2D ? " d-none" : "")}
            />
            <div className="mt-3">
                {typeof _data.que === "string"
                    ? values.map((v) => (
                          <Form.Group className="form-grp" key={"page_10_op_" + v.el}>
                              <Form.Label>{v.label}</Form.Label>
                              <Form.Control
                                  type="number"
                                  value={_data[v.el]}
                                  onChange={(e) => {
                                      setData(
                                          {..._data, [v.el]: e.target.value !== "0" ? e.target.value : ""},
                                          "page10",
                                      );
                                  }}
                              />
                          </Form.Group>
                      ))
                    : ""}
            </div>
        </Form>
    );
}
